module.exports = __webpack_public_path__ + "media/images/sign_in_with_facebook-46eedcf59bcd2d9d30e882c863135024.png";